export * from './remitos-fecha-selector.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/administracion/remitos/common/remitos-fecha-selector/index.ts